import { cn } from '@shared/utils/cn'

function GalleryItem({ item, isMobile }) {
  const isYouTube = item.type === 'video' && item.url?.includes('youtube.com')

  return (
    <div className="flex flex-col gap-1">
      <div className="rounded-[8px] overflow-hidden">
        {item.type === 'image' ? (
          item.url ? (
            <img
              src={item.url}
              alt={item.caption || ''}
              className="w-full h-auto block"
              loading="lazy"
            />
          ) : null
        ) : item.url ? (
          isYouTube ? (
            <div className="relative aspect-video">
              <iframe
                src={item.url.replace('watch?v=', 'embed/')}
                className="absolute inset-0 w-full h-full border-0"
                allowFullScreen
              />
            </div>
          ) : (
            <video
              src={item.url}
              className="w-full h-auto block"
              controls
            />
          )
        ) : null}
      </div>
      {item.caption && (
        <p className="text-xs text-center text-[#44413D] px-1">{item.caption}</p>
      )}
    </div>
  )
}

export function GalleryView({ data, config, isMobile }) {
  const items = (data?.items ?? []).filter(item => item.url)
  if (items.length === 0) return null

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 gap-2">
        {items.map(item => (
          <GalleryItem key={item.id} item={item} isMobile={isMobile} />
        ))}
      </div>
    </div>
  )
}
